import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { BodyCargaPlanes } from 'src/app/interfaces/body_cargaPlanes';
import { BodyEnvioPlanes } from 'src/app/interfaces/body_envioPlanes';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { PlanModels } from 'src/app/models/plan_models';
import { ARMA_TU_PLAN, DATOS_PROPIETARIO, ERROR } from 'src/app/routes.constants';
import { DataLayerService } from 'src/app/services/dataLeyer/data-leyer.service';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';

@Component({
  selector: 'app-cards-planes',
  templateUrl: './cards-planes.component.html',
  styleUrls: ['./cards-planes.component.scss']
})
export class CardsPlanesComponent implements OnInit {

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  json: string = '';
  jsonFinal: string = '';

  dataEnvio: BodyEnvioPlanes = {
    SessionId: '',
    productFamily: '',
    leadId: '',
    asesorCode: '',
    bitacoraId: '',
    screenPercentage: '',
    productsConfigurationData: {
      ProductCode: '',
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentNumber: '',
        DocumentType: ''
      },
      Property: {
        TemporaryContracted: '',
        ContractStartDate: '',
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: '',
        // new atrivutes for Property
        DepartmentCode: '',
        CityProperty: '',
        Code: '',
        CityCode: ''


      }
    }
  };

  dataCarga: BodyCargaPlanes = {
    getPriceData: false,
    leadId: '',
    productsConfigurationData: {
      Property: {
        AdministrationValue: 0,
        Department: '',
        RentalFee: 0,
        TemporaryContracted: ''
      }
    }
  };
  response!: ResponseServices;
  parametro: string = '';
  planes!: PlanModels;
  sessionId: string = '';
  leadId: string = '';
  @Input() identLead!: string;
  codAsesor: string = '';
  IdBitacora: string = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService,
    private _dataLayerService: DataLayerService
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  @Input() infoCliente?: string;
  @Input() idLead?: string;

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoCliente');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
        this.parametro = JSON.stringify(this.datosGenerales);
      }
      else {
        const paramInfoCliente = this.infoCliente;
        const paramIdLead = this.idLead;
        this.leadId = paramIdLead !== undefined ? paramIdLead : '';

        if (paramInfoCliente !== undefined) {
          this.json = paramInfoCliente;
          this.jsonFinal = atob(this.json);
          this.datosGenerales = JSON.parse(this.jsonFinal);
          this.parametro = JSON.stringify(this.datosGenerales);
        }
      }
    });

    this.dataCarga.getPriceData = true;
    this.dataCarga.leadId = this.leadId;
    this.dataCarga.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.dataCarga.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.dataCarga.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.dataCarga.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;


    this.orquestadorService.postOrquestadorPlanes(this.dataCarga).
      subscribe(
        (data) => {
          this.planes = data;
        },
        (error) => {
          this.router.navigate([ERROR, { porcPll: '25', msnPll: 'Falla en la tarificación', infoViaje: btoa(this.parametro) }]);
          return;
        }
      );
  }

  ResumenPlan(code: number) {
    this.datosGenerales.PlanSeleccionado.plan = this.planes.data[code].planName;
    this.datosGenerales.PlanSeleccionado.valorPlan = this.planes.data[code].price;
    this.parametro = JSON.stringify(this.datosGenerales);

    this._dataLayerService.logPlanes('ecommerce_step_4', 'Arrendamiento', 'Planes',
      this.sessionId, this.datosGenerales.InfoArrendamiento.valorArriendo.toString(),
      this.datosGenerales.InfoArrendamiento.valorAdministracion.toString(),
      this.datosGenerales.InfoArrendamiento.tipoPropiedad,
      this.datosGenerales.InfoArrendamiento.ubicacion, this.datosGenerales.InfoArrendamiento.ubicacion,
      this.datosGenerales.InfoArrendamiento.duracionContrato,
      this.datosGenerales.InfoArrendamiento.fechaContrato, this.planes.data[code].planName,
      this.planes.data[code].price.toString(), this.datosGenerales.InfoArrendamiento.ServiciosPublicos ? 'true' : 'false',
      this.datosGenerales.InfoArrendamiento.PaquetesAsistencia ? 'true' : 'false');

    this.GuardarDataLayer();
    this.router.navigate([DATOS_PROPIETARIO, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }

  ArmarPlan(code: number) {
    this.datosGenerales.PlanSeleccionado.plan = this.planes.data[code].planName;
    this.datosGenerales.PlanSeleccionado.valorPlan = this.planes.data[code].price;
    this.parametro = JSON.stringify(this.datosGenerales);

    this.router.navigate([ARMA_TU_PLAN, { codigoAsesor: this.codAsesor, idLead: this.leadId, infoCliente: btoa(this.parametro), bitacoraId: this.IdBitacora }]);
  }

  private GuardarDataLayer() {
    this.dataEnvio.SessionId = this.sessionId;
    this.dataEnvio.productFamily = "Arrendamientos";
    this.dataEnvio.leadId = this.leadId;

    if (this.codAsesor === 'undefined') {
      this.codAsesor = '';
      this.dataEnvio.asesorCode = this.codAsesor;
    }

    if (this.codAsesor != '') {
      this.dataEnvio.asesorCode = this.codAsesor;
    }
    else {
      this.codAsesor = '';
      this.dataEnvio.asesorCode = this.codAsesor;
    }

    this.dataEnvio.bitacoraId = this.IdBitacora;
    this.dataEnvio.screenPercentage = "25";
    this.dataEnvio.productsConfigurationData.ProductCode = this.datosGenerales.PlanSeleccionado.plan;
    this.dataEnvio.productsConfigurationData.PolicyHolder.LastName = this.datosGenerales.Cliente.nombreCliente;
    this.dataEnvio.productsConfigurationData.PolicyHolder.MobilePhone = this.datosGenerales.Cliente.celularCliente.toString();
    this.dataEnvio.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = true;
    this.dataEnvio.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Cliente.cedulaCliente.toString();
    this.dataEnvio.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Cliente.tipoIdentificacion;
    this.dataEnvio.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.dataEnvio.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.dataEnvio.productsConfigurationData.Property.Department = this.datosGenerales.InfoArrendamiento.ubicacion;
    this.dataEnvio.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.dataEnvio.productsConfigurationData.Property.ContractStartDate = this.datosGenerales.InfoArrendamiento.fechaContrato;
    this.dataEnvio.productsConfigurationData.Property.TemporaryContracted = this.datosGenerales.InfoArrendamiento.duracionContrato;
    this.dataEnvio.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.dataEnvio.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.dataEnvio.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
    this.dataEnvio.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;


    this.orquestadorService.postOrquestadorEnvioGen(this.dataEnvio).
      subscribe(
        (data) => {
          this.response = data;
        }
      );
  }

}
